import type { CoachGame } from './api'
import { isUpcoming } from './nextGame'

/** The upcoming games a card can be printed for: today or later, and not an
 *  Area or Section fixture (design spec §8 — those get no card, which is why
 *  the game list withholds the per-game button on them too).
 *
 *  ⚠️ `isUpcoming` reads the BROWSER's date while the server reads the
 *  league's zone. They agree for anyone in the region; a coach in another
 *  timezone can at worst be offered a sheet the server then declines (a
 *  toast), never a sheet for the wrong games. */
export function cardableUpcoming(games: CoachGame[]): CoachGame[] {
  return games.filter((g) => isUpcoming(g.date) && !g.external_opponent)
}

/** The two-up games button's label, or null when this team has nothing
 *  upcoming to print.
 *
 *  The label names what actually comes out of the printer: with one game left
 *  in the season the sheet's right half is a blank card, and a button reading
 *  "next two games" would be a promise the PDF does not keep. */
export function twoUpGamesLabel(games: CoachGame[]): string | null {
  const count = cardableUpcoming(games).length
  if (count === 0) return null
  return count === 1 ? 'Download next game and a blank card' : 'Download next two games'
}
